import { useEffect, useState, useRef } from "react";
import moment from 'moment'
import BottomIcon from '@src/component/bottomIcon'
import "./index.scss";
import { Form, Input, Toast } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import UploadImg from '@src/component/uploadImg'
import { imageSyncScan, sendAuthCode, saveByInformation, getResult, getApplyInfoByIdf } from "@service/applyFormSubService"
import { hasLoanAndQuaStatus } from "@src/service/ownService";
import { isEmpty, regular, verifyPhone, verifyIdentify } from "@src/util";
import store from '@src/util/store'
import { gotor, goto } from "@src/route";

export default function Index() {
    const [form] = Form.useForm()
    const [identityFrony, setIdentityFrony] = useState<any>(null)
    const [identityReverse, setIdentityReverse] = useState<any>(null)
    const [inputShow, setInputShow] = useState<boolean>(false)
    const [forbidden, setForbidden] = useState<boolean>(true)
    const [verify, setVerify] = useState<boolean>(false)
    const [duration, setDuration] = useState<number>(0)
    const [id, setId] = useState(null)
    const [no, setNo] = useState(null)
    const refFrony = useRef(null);
    const refReverse = useRef(null);
    useEffect(() => {
        (async () => {
            try {
                Toast.show({
                    icon: 'loading',
                    content: '加载中…',
                    duration: 0,
                    maskClickable: false
                })
                const { code } = await hasLoanAndQuaStatus() || {};
                Toast.clear()
                if (code === 999) {
                    Toast.show({
                        content: '您已有业务办理成功，暂不支持新的业务办理',
                        duration: 1000,
                        afterClose: () => {
                            gotor('/rzIndex');
                        },
                    })
                }
                // 当前无业务
                else if ([0, 1, 2, 4, 9].includes(code)) {
                    gotor('/rzStatus');
                }
            } catch (err: any) {
                Toast.show({
                    content: err?.errmsg || '状态查询失败',
                    duration: 1000,
                    afterClose: () => {
                        gotor('/rzIndex');
                    },
                })
            }
        })()
    }, [])
    // 设置title
    useEffect(() => {
        // 判断验证码
        if (store.get('time')) {
            try {
                const date = Math.floor((-new Date() - store.get('time')) / 1000 + 60)
                if (date > 0 && date < 60) {
                    countDown(date)
                    setVerify(true)
                }
            } catch (e) {
                console.log(e)
            }
        }
        document.title = "实名认证";
    }, [])

    // 判断是否显示身份输入信息
    useEffect(() => {
        if (identityFrony) {
            setInputShow(true)
        } else {
            setInputShow(false)
        }
    }, [identityFrony])

    // 回填数据
    useEffect(() => {
        // 获取提交数据
        getResult().then(res => {
            if (res) {
                setId(res.id)
                setNo(res.no)
                setData(res)
                getApplyInfoByIdf().then(ret => {
                    if (ret?.qualification) {
                        store.set('qualification', ret?.qualification)
                    }
                }).catch((err: any) => {
                    err?.errmsg && Toast.show(err?.errmsg)
                })
            } else {
                // 获取历史数据
                getApplyInfoByIdf().then(ret => {
                    if (ret?.qualification) {
                        setData(ret?.qualification)
                        store.set('qualification', ret?.qualification)
                    }
                }).catch((err: any) => {
                    err?.errmsg && Toast.show(err?.errmsg)
                })
            }
        }).catch(err => {
            err?.errmsg && Toast.show(err?.errmsg)
        })
    }, [])

    // 回填数据
    const setData = (res: any) => {
        form.setFieldsValue({
            identifyAddress: res.identifyAddress,
            identifyNumber: res.identifyNumber,
            name: res.name,
            mobile: res.mobile
        })
        if (res.idf) {
            setIdentityFrony({
                id: res.idf,
                identifyAddress: res.identifyAddress,
                idCar: res.identifyNumber,
                name: res.name,
                sex: res.sex
            });
            (refFrony?.current as any)?.setFileList([{ url: res.idfUrl }])
        }
        if (res.idb) {
            setIdentityReverse({
                id: res.idb,
                endDate: moment(res.validEndDate).format('YYYY-MM-DD'),
                startDate: moment(res.validStartDate).format('YYYY-MM-DD')
            });
            (refReverse?.current as any)?.setFileList([{ url: res.idbUrl }])
        }

        setTimeout(() => {
            if (regular('phone').test(form.getFieldValue('mobile'))) {
                setForbidden(false)
            } else {
                setForbidden(true)
            }
        }, 200);
    }
    // 身份证正面
    const onChanegeFrony = (file: any) => {
        if (file[0] && file[0].id) {
            Toast.show({
                icon: 'loading',
                content: '身份证识别中…',
                duration: 0,
                maskClickable: false
            })
            imageSyncScan(file[0].id, 1).then(res => {
                Toast.clear()
                if (!isEmpty(res.address) && !isEmpty(res.idCar) && !isEmpty(res.name)) {
                    setIdentityFrony({
                        id: file[0].id,
                        identifyAddress: res.address,
                        idCar: res.idCar,
                        name: res.name,
                        sex: res.sex
                    })
                    form.setFieldsValue({
                        identifyAddress: res.address,
                        identifyNumber: res.idCar,
                        name: res.name
                    })
                } else {
                    Toast.show('身份信息识别失败')
                    setIdentityFrony(null);
                    (refFrony?.current as any)?.setFileList([])
                }
            }).catch(err => {
                Toast.show(err?.errmsg || '身份信息识别失败')
                setIdentityFrony(null);
                (refFrony?.current as any)?.setFileList([])
            })
        } else {
            setIdentityFrony(null)
        }
    }

    // 身份证反面
    const onChanegeReverse = (file: any) => {
        if (file[0] && file[0].id) {
            Toast.show({
                icon: 'loading',
                content: '身份证识别中…',
                duration: 0,
                maskClickable: false
            })
            imageSyncScan(file[0].id, 2).then(res => {
                Toast.clear()
                if (!isEmpty(res.endDate) && !isEmpty(res.startDate)) {
                    setIdentityReverse({
                        id: file[0].id,
                        authority: res.authority,
                        endDate: res.endDate,
                        startDate: res.startDate
                    })
                } else {
                    Toast.show('身份信息识别失败')
                    setIdentityReverse(null);
                    (refReverse?.current as any)?.setFileList([])
                }
            }).catch(err => {
                Toast.show(err?.errmsg || '身份信息识别失败')
                setIdentityReverse(null);
                (refReverse?.current as any)?.setFileList([])
            })
        } else {
            setIdentityReverse(null)
        }
    }

    // 倒计时
    const countDown = (time: number) => {
        setDuration(time)
        setTimeout(() => {
            const t = time - 1
            if (t > 0) {
                countDown(t)
            } else {
                store.remove('time')
                setVerify(false)
            }
        }, 1000);
    }

    // 发送验证码
    const sendCode = () => {
        if (forbidden || verify) {
            return
        }
        Toast.show({
            icon: 'loading',
            content: '加载中…',
            duration: 0
        })
        sendAuthCode(form.getFieldValue('mobile')).then(res => {
            Toast.show(res)
            store.set('time', -new Date())
            setVerify(true)
            countDown(60)
        }).catch(err => {
            Toast.show(err?.errmsg || '短信验证码发送失败')
        })
    }

    // 点击下一步
    const netxClick = () => {
        if (!identityFrony) {
            Toast.show('请上传您的身份证正面')
            return
        }
        if (!identityReverse) {
            Toast.show('请上传您的身份证反面')
            return
        }
        form.validateFields().then(res => {
            res.validStartDate = identityReverse.startDate
            res.validEndDate = identityReverse.endDate
            res.idf = identityFrony.id
            res.idb = identityReverse.id
            res.sex = identityFrony.sex || '男'
            res.no = no
            res.id = id
            res.modelId = store.get('cheliang')?.id
            res.modelName = store.get('cheliang')?.vehicleFullName
            Toast.show({
                icon: 'loading',
                content: '加载中…',
                duration: 0,
                maskClickable: false
            })
            saveByInformation(res).then(() => {
                Toast.clear()
                goto('/instalments')
            }).catch(err => {
                Toast.show(err?.errmsg || '用户信息保存失败！')
            })
        })
    }

    return (<div className="page bottomFit uploadId">
        <CustomScroll>
            <div style={{paddingBottom: 100}}>
                <header>
                    <div className="title dotted-line">请上传您的身份证正反面</div>
                    <div className="upz">
                        <div className="uploadId-box">
                            <UploadImg ref={refFrony} onChanege={onChanegeFrony}>
                                <div className="box-show">
                                    <div className="upload-Icon">
                                        <div className="upload-peoIcon">
                                            <i className="upload-addIcon"></i>
                                        </div>
                                    </div>
                                </div>
                            </UploadImg>
                            {!inputShow && <div className="box-text">点击上传身份证人像面</div>}
                        </div>
                        <div className="uploadId-box">
                            <UploadImg ref={refReverse} onChanege={onChanegeReverse}>
                                <div className="box-show">
                                    <div className="upload-Icon">
                                        <div className="upload-peoIcon national">
                                            <i className="upload-addIcon"></i>
                                        </div>
                                    </div>
                                </div>
                            </UploadImg>
                            {!inputShow && <div className="box-text">点击上传身份证国徽面</div>}
                        </div>
                    </div>
                </header>
                {(!inputShow) && <section>
                    <ul>
                        <li>
                            <div className="content-img">
                                <div className="content-IDright" />
                            </div>
                            <div className="content-text"><i className="rightIcon" />标准拍摄</div>
                        </li>
                        <li>
                            <div className="content-img">
                                <div className="content-IDdef" />
                            </div>
                            <div className="content-text"><i className="defIcon" />边框缺失</div>
                        </li>
                        <li>
                            <div className="content-img">
                                <div className="content-IDright dim" />
                            </div>
                            <div className="content-text"><i className="defIcon" />照片模糊</div>
                        </li>
                    </ul>
                </section>}
                {inputShow && <div className="inputForm">
                    <div className="title dotted-line">请确认您的身份信息</div>
                    <Form form={form} layout='horizontal'>
                        <Form.Item name='name' label='姓&nbsp;&nbsp;&nbsp;&nbsp;名：' rules={[{ required: true, message: '请输入姓名' }, { min: 2, max: 20, message: "姓名长度为2-20个字符" }]}>
                            <Input placeholder='请输入姓名' maxLength={20} minLength={2} />
                        </Form.Item>
                        <Form.Item name="identifyNumber" label='身份证号：' rules={[{ validator: verifyIdentify }]}>
                            <Input placeholder='请输入身份证号' maxLength={18} />
                        </Form.Item>
                        <Form.Item name="identifyAddress" label='身份证地址：' rules={[{ required: true, message: '请输入身份证地址' }]}>
                            <Input placeholder='请输入身份证地址' maxLength={40} />
                        </Form.Item>
                        <Form.Item name="mobile" label='手机号码：' rules={[{ validator: verifyPhone }]}>
                            <Input placeholder='请输入手机号码' type="number" onChange={() => {
                                form.setFieldsValue({
                                    mobile: form.getFieldValue('mobile').replace(/\D/g, '').substring(0, 11)
                                })
                                setTimeout(() => {
                                    if (regular('phone').test(form.getFieldValue('mobile'))) {
                                        setForbidden(false)
                                    } else {
                                        setForbidden(true)
                                    }
                                }, 200);
                            }} />
                        </Form.Item>
                        <Form.Item name="sfyzm" label='验证码：' rules={[{ required: true, message: '请输入验证码' }]} extra={
                            <div onClick={sendCode} className={`verification ${forbidden || verify ? 'forbidden' : ''}`}>{verify ? `${duration}s后重新获取` : '获取验证码'}</div>
                        }>
                            <Input placeholder='短信验证码' />
                        </Form.Item>
                    </Form>
                </div>}
                
            </div>
           
        </CustomScroll>
        <footer>
            <div className="button-them upload-next" onClick={netxClick}>下一步</div>
        </footer>
        <BottomIcon />
    </div>)
}
